function pushHistory(searchString) {
  const url = document.location.pathname + "#/?" + searchString;

  history.pushState(
    {
      storiesHistoryUrl: url,
    },
    null,
    url
  );
}
export { pushHistory };
